import React from 'react';
import shortid from 'shortid';
import PropTypes from 'prop-types';
import camelCase from 'lodash/camelCase';

import instagramIconRegular from 'assets/images/instagram.svg';
import facebookIconRegular from 'assets/images/facebook.svg';
import linkedInIconRegular from 'assets/images/linkedin.svg';
import twitterIconRegular from 'assets/images/twitter.svg';
import instagramIconCircular from 'assets/images/instagram-logo-circular.svg';
import facebookIconCircular from 'assets/images/facebook-logo-circular.svg';
import linkedInIconCircular from 'assets/images/linkedin-logo-circular.svg';
import twitterIconCircular from 'assets/images/twitter-logo-circular.svg';
import { SOCIAL_LINKS } from 'config';

import { socialMediaLink } from './scss/SocialMediaLinks.module.scss';

const SocialMediaLinks = ({ iconType, className }) => {
  const iconMap = {
    instagramIconRegular,
    instagramIconCircular,
    facebookIconRegular,
    facebookIconCircular,
    linkedInIconRegular,
    linkedInIconCircular,
    twitterIconRegular,
    twitterIconCircular,
  };
  const socialLinks = [
    { name: 'instagram', href: SOCIAL_LINKS.INSTAGRAM },
    { name: 'facebook', href: SOCIAL_LINKS.FACEBOOK },
    { name: 'linkedIn', href: SOCIAL_LINKS.LINKED_IN },
    { name: 'twitter', href: SOCIAL_LINKS.TWITTER },
  ].map(link => {
    const iconName = camelCase(`${link.name}-icon-${iconType}`);
    return {
      ...link,
      icon: iconMap[iconName],
    };
  });
  return (
    <div className={className}>
      {socialLinks.map(link => (
        <a
          key={shortid()}
          href={link.href}
          title={`${link.name} link`}
          className={socialMediaLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={link.icon} alt={`${link.name} link icon`} />
        </a>
      ))}
    </div>
  );
};

SocialMediaLinks.propTypes = {
  iconType: PropTypes.oneOf(['regular', 'circular']),
  className: PropTypes.string,
};

SocialMediaLinks.defaultProps = {
  iconType: 'regular',
  className: '',
};

export default SocialMediaLinks;
